import { client } from '../sanity'
import type { Channel } from '@/types/channel'

/**
 * Fetch all enabled channels
 */
export const getEnabledChannels = async (): Promise<Channel[]> => {
  // Fallback: return all channels ordered by name (schema doesn't define "enabled")
  return client.fetch(
    `*[_type == "channel"] | order(name asc) {
      _id,
      _type,
      name,
      activeIntegration,
      integrationIdentifier,
      rates
    }`
  )
}

/**
 * Fetch all channels (including disabled)
 */
export const getAllChannels = async (): Promise<Channel[]> => {
  return client.fetch(
    `*[_type == "channel"] | order(name asc)`
  )
}

/**
 * Fetch a single channel by code
 */
export const getChannelByCode = async (
  code: string
): Promise<Channel | null> => {
  return client.fetch(
    `*[_type == "channel" && integrationIdentifier == $code][0]`,
    { code }
  )
}
